export default __webpack_public_path__ + "static/media/7.96bfa9f9.jpg";